export const urlParams=function(para){
  var temp = window.location.href.split('?')[1];
  var param = new URLSearchParams('?'+temp);
  if(para)
  return param.get(para);
  return param;
}
export const typeOf = obj => {
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object',
  }
  return map[toString.call(obj)]
}

export const deepMerge = (target, merged) => {
  for (var key in merged) {
    if (target[key] && typeOf(target[key]) === 'object') {
      deepMerge(target[key], merged[key])
      continue
    }

    if (typeOf(merged[key]) === 'object') {
      target[key] = deepCopy(merged[key])
      continue
    }

    target[key] = merged[key]
  }

  return target
}
/**
 *深拷贝组件数据，特殊处理的业务如下：
 1. key为id时 genID重新为id赋值
 2. 图片相关内容复制时需要特殊处理，比如imgObj中type是否需要从custom修改为system？？？【待确认，待实现】
 【完善之后，需要把store中组件复制的方法替换成这个】
  */ 
export const deepCopyComponentData = (data,p) => {
  const t = typeOf(data)
  let o
  if (t === 'array') {
    o = []
  } else if (t === 'object') {
    o = {}
  } else {
    return data
  }
  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
    o.push(deepCopyComponentData(data[i]))
    }
  } else if (t === 'object') {
    for (let i in data) {
      if (p == "imgObj" && i == "type") {
        o[i] = "system";
      }
      else if(i=='id'){
        o[i] = (data.idPrefix||data.type)+'_'+genID();
      }else if(i == "table_uuid"){
        o[i] = genID();
      }else if(i == "form_uuid"){
        o[i] = genID();
      }else if(i == "tree_uuid"){
        o[i] = genID();
      }
      else{
        o[i] = deepCopyComponentData(data[i],i)
      }
    }
  }
  return o
}

// 修改组件中图片的类型，设为模板时使用
export const changeComponentImg = (data,p) => {
  const t = typeOf(data)
  let o
  if (t === 'array') {
    o = []
  } else if (t === 'object') {
    o = {}
  } else {
    return data
  }
  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
    o.push(changeComponentImg(data[i]))
    }
  } else if (t === 'object') {
    for (let i in data) {
      if (p == "imgObj" && i == "type") {
        o[i] = "system";
      }
      else{
        o[i] = changeComponentImg(data[i],i)
      }
    }
  }
  return o
}

// 深拷贝，若某字段值为"${getNew}"，则通过genID()重新赋值
export const deepCopySpecial = data => {
  const t = typeOf(data)
  let o

  if (t === 'array') {
    o = []
  } else if (t === 'object') {
    o = {}
  } else {
    return data==="${getNew}"?genID():data
  }

  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopySpecial(data[i]))
    }
  } else if (t === 'object') {
    for (let i in data) {
      o[i] = deepCopySpecial(data[i])
    }
  }
  return o
}
// 深拷贝
export const deepCopy = data => {
  const t = typeOf(data)
  let o

  if (t === 'array') {
    o = []
  } else if (t === 'object') {
    o = {}
  } else {
    return data
  }

  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]))
    }
  } else if (t === 'object') {
    for (let i in data) {
      o[i] = deepCopy(data[i])
    }
  }
  return o
}
export const deepClone = function(obj, cache) {
  if (cache === void 0) {
    cache = new Map([])
  }
  if (obj === null || typeof obj !== 'object') return obj
  if (cache.has(obj)) return cache.get(obj)
  // eslint-disable-next-line
  var clone = Array.isArray(obj) ? [] : {}
  cache.set(obj, clone)
  // @ts-ignore
  Object.keys(obj).forEach(function(key) {
    return (clone[key] = deepClone(obj[key], cache))
  })
  return clone
}
// 对比JS中两个对象是否相等
export const deepCompare = function(x, y) {
  var i, l, leftChain, rightChain

  function compare2Objects(x, y) {
    var p

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
      return true
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y) {
      return true
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if (
      (typeof x === 'function' && typeof y === 'function') ||
      (x instanceof Date && y instanceof Date) ||
      (x instanceof RegExp && y instanceof RegExp) ||
      (x instanceof String && y instanceof String) ||
      (x instanceof Number && y instanceof Number)
    ) {
      return x.toString() === y.toString()
    }

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object)) {
      return false
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
      return false
    }

    if (x.constructor !== y.constructor) {
      return false
    }

    if (x.prototype !== y.prototype) {
      return false
    }

    // Check for infinitive linking loops
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
      return false
    }

    // Quick checking of one object being a subset of another.
    // todo: cache the structure of arguments[0] for performance
    for (p in y) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false
      } else if (typeof y[p] !== typeof x[p]) {
        return false
      }
    }

    for (p in x) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false
      } else if (typeof y[p] !== typeof x[p]) {
        return false
      }

      switch (typeof x[p]) {
        case 'object':
        case 'function':
          leftChain.push(x)
          rightChain.push(y)

          if (!compare2Objects(x[p], y[p])) {
            return false
          }

          leftChain.pop()
          rightChain.pop()
          break

        default:
          if (x[p] !== y[p]) {
            return false
          }
          break
      }
    }

    return true
  }

  if (arguments.length < 1) {
    return true //Die silently? Don't know how to handle such case, please help...
    // throw "Need two or more arguments to compare";
  }

  for (i = 1, l = arguments.length; i < l; i++) {
    leftChain = [] //Todo: this can be cached
    rightChain = []

    if (!compare2Objects(arguments[0], arguments[i])) {
      return false
    }
  }

  return true
}

/**
 * 获取两个对象中第一层属性间差异的键值对，例如：
 * const x = {
    a: 1,
    b: 2,
    c: { foo: 1, bar: 2},
    d: { baz: 1, bat: 2 }
  }
 * const y = {
    b: 2, 
    c: { foo: 1, bar: 'monkey'}, 
    d: { baz: 1, bat: 2 }
    e: 1
  }
 * console.log (diff (x, y)) // ["c", "e", "a"]
 */
export const getObjectDiff = (obj1, obj2) => {
  const diff = Object.keys(obj1).reduce((result, key) => {
    if (!obj2.hasOwnProperty(key)) {
      result.push(key)
    } else if (deepCompare(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key)
      result.splice(resultKeyIndex, 1)
    }
    return result
  }, Object.keys(obj2))

  return diff
}

/**
 * 时间戳+定时器 节流方法
 * 当第一次触发事件时马上执行事件处理函数，最后一次触发事件后也还会执行一次事件处理函数
 * @param {Function} fn 处理函数
 * @param {Number} delay 延时时间
 */
export const throttle = function(fn, delay = 500) {
  var timer = null
  var startTime = Date.now()
  return function() {
    var curTime = Date.now()
    var remaining = delay - (curTime - startTime)
    var context = this
    var args = arguments
    clearTimeout(timer)
    if (remaining <= 0) {
      fn.apply(context, args)
      startTime = Date.now()
    } else {
      timer = setTimeout(fn, remaining)
    }
  }
}

/**
 * 防抖方法
 * @param {Function} fn 处理函数
 * @param {Number} delay 延时时间
 */
export const debounce = function(fn, delay = 500, immediate = false) {
  let timer = null // 闭包存储setTimeout状态
  return function() {
    let self = this // 事件源this
    let args = arguments // 接收事件源的event
    if (timer) clearTimeout(timer) // 存在就清除执行fn的定时器
    if (immediate) {
      // 立即执行
      let callNow = !timer // 执行fn的状态
      timer = setTimeout(function() {
        timer = null
      }, delay)
      if (callNow) fn.apply(self, args)
    } else {
      // 非立即执行
      timer = setTimeout(function() {
        // 或者使用箭头函数将this指向dom
        fn.apply(self, args)
      }, delay)
    }
  }
}
/**
 * 判断字符串是否为json格式数据
 * @param {String} str 待检测字符串
 */
export const isJsonString = str => {
  try {
    if (typeof JSON.parse(str) == 'object') {
      return true
    }
  } catch (e) {}
  return false
}
// 解决浮点数相加精度问题
export const add = (num1, num2) => {
  return +parseFloat((num1 + num2).toPrecision(12))
}
export function uuid(hasHyphen) {
  return (hasHyphen
    ? 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    : 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'
  ).replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0
    const v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const on = (function() {
  if (document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
})();

export function checkUrl(url){
  var objExp=new RegExp('/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/');
  return objExp.test(url);
}
export function isJSON(str) {
  if (typeof str == 'string') {
      try {
          var obj=JSON.parse(str);
          return true;
      } catch(e) {
          return false;
      }
  }
}

export function genID() {
  return Number(Math.random().toString().substr(3, 20) + Date.now()).toString(36);
}
export function isEmpty(obj){
  if(typeof obj == "undefined" || obj == null || obj == ""){
      return true;
  }else{
      return false;
  }
}
/**
 * 获取文件类型
 * @param {String} ext 文件后缀名
 */
export function getFileCategory(ext){
  let categoryMap = {
    "doc":["txt", "doc", "docx", "ppt", "pptx", "pptm", "xls", "xlsx", "wps", "rtf", "htm", "html", "pdf" ],
    "pic":[ "ai", "bmp", "cur", "dcx", "emf", "eps", "gif", "icn", "ico", "iff", "jpg", "jpeg", "jpe", "jif", "pcd", "pcx", "pic", "pix", "png", "exif", "svg", "raw", "ras", "rsb", "sgi", "tga", "tiff", "wmf" ],
    "music":[ "ac3", "ape", "aac", "amr", "cda", "flac", "mp1", "mp2", "mp3", "wav", "wma", "m4a", "mid", "mka", "mpa", "mpc", "mmf", "ofr", "ogg", "ra", "ram", "wv", "tta", "dts" ],
    "video":[ "wmv", "asf", "asx", "divx", "rm", "rmvb", "mpg", "mpeg", "mpe", "3gp", "mov", "mp4", "m4v", "avi", "dat", "mkv", "flv", "vob" ],
  }
  let category = "other";
  for (const key in categoryMap) {
    if (Object.hasOwnProperty.call(categoryMap, key)) {
      const element = categoryMap[key];
      if(element.includes(ext)){
        category = key;
      }
    }
  }
  return category;
  
}

function checkIsAppleDevice() {
  var u = navigator.userAgent,
    app = navigator.appVersion;
  var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  var iPad = u.indexOf("iPad") > -1;
  var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
  if (ios || iPad || iPhone) {
    return true;
  } else {
    return false;
  }
}
//js判断是否为Android设备
function checkIsAndroidDevice() {
  var u = navigator.userAgent;
  if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
    return true;
  } else {
    return false;
  }
}      
//js判断是否为鸿蒙系统 chos是鸿蒙webview的标识
function checkIsHarmonyOS() {
  var u = navigator.userAgent;
  if (u.indexOf("ohos") > -1) {
    return true;
  } else {
    return false;
  }
}
export function getEnvironment (){
  var isMobile = false;
  var isPC = false;
  var isWechart = false;
  var isIOS = false;
  var isAndroid = false;
  var isHMOS = false; //鸿蒙
  let ua = navigator.userAgent
  if(/(micromessenger)/i.test(ua)){
    isWechart = true
  }else if(/Android|webOS|iPhone|ipad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) || !!ua.match(/AppleWebKit.*Mobile.*/)){
    isMobile = true
  }else{
    isPC = true
  }
  if (checkIsAppleDevice()) {
    isIOS = true
  } else if (checkIsHarmonyOS()) {
    isHMOS = true
    isAndroid = true
  } else if(checkIsAndroidDevice()){
    isAndroid = true
  }
  return {isMobile,isPC,isWechart,isIOS,isHMOS,isAndroid}
}